export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const formattedDate = `${date.getFullYear()}.${('0' + (date.getMonth() + 1)).slice(-2)}.${('0' + date.getDate()).slice(-2)}`;
  return formattedDate;
};